<div class="p-6 my-8 bg-white review-container rounded-2xl">
  <!-- Header -->
  <h2
    class="text-2xl font-semibold leading-8 text-gray-900 capitalize font-raleway">
    Review Your Order Request
  </h2>
  <p class="mt-2 text-base font-normal leading-6 text-gray-500 font-raleway">
    Take a minute to look over your order request. Make sure all items and
    information are correct before proceeding.
  </p>
  <div class="w-full h-px my-4 bg-gray-300"></div>

  <!-- Order Summary -->
  <div class="p-5 mb-6 bg-white border border-gray-200 shadow-md rounded-2xl">
    <div class="flex items-center space-x-3">
      <img src="/dashboard/home.svg" alt="home" class="w-6 h-6" />
      <h3
        class="flex items-center text-lg font-semibold text-gray-900 font-raleway">
        Your requested order summary
        <span
          class="px-3 py-1 ml-3 text-sm font-medium text-blue-600 bg-blue-100 rounded-md">
          1 Service
        </span>
      </h3>
    </div>

    <div class="p-4 my-4 border border-gray-200 rounded-xl">
      <div
        class="flex items-center justify-between pb-3 border-b border-gray-200">
        <span class="font-medium text-gray-700"></span>
        <a href="#" class="font-medium text-blue-600 underline">Change</a>
      </div>
      <div class="pt-3">
        <div class="flex justify-between">
          <p class="text-gray-700">{{selectedPlan()?.name}}</p>
          <p class="font-semibold text-gray-900">{{selectedPlan()?.amount | currency: 'USD':'symbol':'1.0-0' }}/mo</p>
        </div>
        <p class="text-sm text-gray-500">Download speed: {{selectedPlan()?.download_speed}} Mbps</p>
        <p class="text-sm text-gray-500">Upload speed: {{selectedPlan()?.upload_speed}} Mbps</p>
      </div>
    </div>

    <!-- Monthly Charges -->
    <div class="p-4 mt-4 bg-blue-50 rounded-xl">
      <div class="flex items-center justify-between mb-3">
        <h4 class="font-semibold text-gray-900">Monthly charges</h4>
        <h4 class="font-semibold text-gray-900">{{selectedPlan()!.amount | currency: 'USD':'symbol':'1.0-0' }}</h4>
      </div>
      <div class="flex items-center justify-between">
        <span class="text-gray-500">Subtotal</span>
        <span class="font-semibold text-gray-900">{{selectedPlan()?.amount | currency: 'USD':'symbol':'1.0-0' }}</span>
      </div>
    </div>

    <!-- Alert -->
    <div
      class="flex items-center p-4 mt-4 space-x-2 bg-yellow-100 border border-yellow-300 rounded-lg">
      <i class="text-lg text-yellow-600 pi pi-info-circle"></i>
      <p class="text-sm text-gray-700">
        After submitting your order, our team will contact you to confirm if
        your address is eligible.
      </p>
    </div>
  </div>

  <!-- Requested Service Address -->
  <div class="p-5 mb-6 bg-white border border-gray-200 shadow-md rounded-2xl">
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center space-x-4">
        <img src="/dashboard/address.svg" alt="address" class="w-6 h-6" />
        <h2 class="text-lg font-semibold text-gray-900 font-raleway">
          Requested service address
        </h2>
      </div>
      <a href="#" class="font-medium text-blue-600 underline">Change</a>
    </div>
    <div>
      <h3 class="font-medium text-gray-900">Service Address</h3>
      <p class="text-sm text-gray-500">{{address()?.line1}}</p>
      <p class="text-sm text-gray-500">{{address()?.town}}</p>
      <p class="text-sm text-gray-500">{{address()?.county}}</p>
      <p class="text-sm text-gray-500">{{address()?.postal_code}}</p>
    </div>
  </div>

  <!-- Contact Information -->
  <div class="p-5 mb-6 bg-white border border-gray-200 shadow-md rounded-2xl">
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center space-x-4">
        <img src="/dashboard/user.svg" alt="user" class="w-6 h-6" />
        <h2 class="text-lg font-semibold text-gray-900 font-raleway">
          Contact information
        </h2>
      </div>
      <a href="#" class="font-medium text-blue-600 underline">Change</a>
    </div>
    <div>
      <h3 class="font-medium text-gray-900">Name</h3>
      <p class="my-2 text-sm text-gray-500">{{personalDetails()?.firstName}} {{personalDetails()?.lastName}}</p>
      <h3 class="font-medium text-gray-900">Email</h3>
      <p class="my-2 text-sm text-gray-500">{{personalDetails()?.emailAddress}}</p>
      <h3 class="font-medium text-gray-900">Mobile Phone</h3>
      <p class="my-2 text-sm text-gray-500">{{personalDetails()?.mobilePhone}}</p>
      <h3 class="font-medium text-gray-900">Home Phone</h3>
      <p class="my-2 text-sm text-gray-500">{{personalDetails()?.homePhone}}</p>
    </div>
  </div>

  <!-- Terms and Conditions -->
  <div>
    <div class="flex items-center pt-6 pb-2">
      <img src="/dashboard/doc.svg" alt="doc" class="w-6 h-6 mr-3" />
      <h2 class="text-lg font-semibold text-gray-900 font-raleway">
        Terms and conditions
      </h2>
    </div>
    <p class="text-sm text-gray-500">
      To subscribe to our services, acceptance of our terms and conditions is
      required.
    </p>
    <div class="p-4 mt-4 border border-gray-200 rounded-xl">
      <div class="flex items-center">
        <p-checkbox [(ngModel)]="termsAccepted" binary="true"></p-checkbox>
        <p class="ml-2 text-sm text-gray-700">
          I have read and agree to all the terms and conditions in order to
          subscribe to our services.
        </p>
      </div>
      <div class="mt-4 text-right">
        <button
          pButton
          type="button"
          (click)="submitOrder()"
          [disabled]="!termsAccepted"
          class="px-6 py-3 text-sm font-medium text-white transition bg-blue-600 rounded-lg hover:bg-blue-700 disabled:bg-gray-400">
          <i class="ri-lock-line"></i>
          Place your order request
        </button>
      </div>
    </div>
  </div>
</div>
